import { useContext, useState } from 'react';
import { financingDisclaimers } from 'axl-config';
import { DisclaimerText, Button, Modal, ModalHeader, ModalTitle, ModalBody, Link } from 'reaxl';
import ConfigContext from '../ConfigContext/ConfigContext.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import buildCashDisclaimer from '../NativeDealCalculator/helpers/buildCashDisclaimer.js';
import buildLeaseDisclaimer from '../NativeDealCalculator/helpers/buildLeaseDisclaimer.js';
import buildFinanceDisclaimer from '../NativeDealCalculator/helpers/buildFinanceDisclaimer.js';
function DisclaimerWithModalContent(_ref) {
  let {
    container,
    mainText,
    modalTitle,
    modalText,
    modalTriggerText
  } = _ref;
  const [showModal, setShowModal] = useState(false);
  const toggleDisclaimerModal = () => {
    setShowModal(!showModal);
  };
  return /*#__PURE__*/jsxs(Fragment, {
    children: [mainText, ' ', /*#__PURE__*/jsx(Button, {
      bsStyle: "text-decorated",
      onClick: toggleDisclaimerModal,
      children: modalTriggerText
    }), showModal && /*#__PURE__*/jsxs(Modal, {
      container: container,
      show: showModal,
      onHide: toggleDisclaimerModal,
      bsSize: "large",
      children: [/*#__PURE__*/jsx(ModalHeader, {
        closeButton: true,
        children: /*#__PURE__*/jsx(ModalTitle, {
          children: modalTitle
        })
      }), /*#__PURE__*/jsx(ModalBody, {
        children: modalText
      })]
    })]
  });
}
function Disclaimer(_ref2) {
  let {
    container,
    paymentInfo = {},
    type = 'finance',
    ...rest
  } = _ref2;
  const {
    disclaimerKey,
    shortCustomDisclaimer
  } = useContext(ConfigContext) || {};
  const {
    cash,
    tax = '0',
    tradeEquity,
    ...paymentInfoProps
  } = paymentInfo;
  const {
    financePrivateSellerAvailabilityNote
  } = financingDisclaimers;
  const hasTax = tax !== '0';
  let disclaimer = '';
  let contactDisclaimer;
  if (disclaimerKey === 'PSX') {
    contactDisclaimer = /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx("br", {}), /*#__PURE__*/jsx("br", {}), type === 'finance' && `${financePrivateSellerAvailabilityNote} `, "Please", ' ', /*#__PURE__*/jsx(Link, {
        href: "https://www.autotrader.com/email-us?contactEmail=atc_feedback",
        target: "_blank",
        rel: "noindex nofollow",
        children: "contact customer service"
      }), ' ', "for more information."]
    });
  }

  // Render disclaimer according to digital retailing type and deal type
  switch (type) {
    case 'finance':
      {
        const {
          financeDisclaimerHasModal,
          onPageFinanceDisclaimer,
          ...financeDisclaimerModalData
        } = buildFinanceDisclaimer(paymentInfoProps, hasTax, contactDisclaimer, disclaimerKey, shortCustomDisclaimer);
        disclaimer = financeDisclaimerHasModal ? /*#__PURE__*/jsx(DisclaimerWithModalContent, {
          mainText: onPageFinanceDisclaimer,
          ...financeDisclaimerModalData,
          container: container
        }) : onPageFinanceDisclaimer;
        break;
      }
    case 'lease':
      {
        // Extract lease disclaimer information to be shown on both page and in modal
        const {
          leaseDisclaimerHasModal,
          onPageLeaseDisclaimer,
          ...leaseDisclaimerModalData
        } = buildLeaseDisclaimer(paymentInfoProps, disclaimerKey);
        disclaimer = leaseDisclaimerHasModal ? /*#__PURE__*/jsx(DisclaimerWithModalContent, {
          mainText: onPageLeaseDisclaimer,
          ...leaseDisclaimerModalData,
          container: container
        }) : onPageLeaseDisclaimer;
        break;
      }
    case 'cash':
      {
        const {
          cashDisclaimerHasModal,
          onPageCashDisclaimer,
          ...cashDisclaimerModalData
        } = buildCashDisclaimer(cash, tradeEquity, hasTax, contactDisclaimer, disclaimerKey, shortCustomDisclaimer);
        disclaimer = cashDisclaimerHasModal ? /*#__PURE__*/jsx(DisclaimerWithModalContent, {
          mainText: onPageCashDisclaimer,
          ...cashDisclaimerModalData,
          container: container
        }) : onPageCashDisclaimer;
        break;
      }
  }
  return disclaimer ? /*#__PURE__*/jsx(DisclaimerText, {
    ...rest,
    children: disclaimer
  }) : null;
}
export { Disclaimer as default };
